/* Adventure chrome — header (sticky, smart hide, progress, mega menu,
   drawer, rotating announcements) and footer (reveal, back to top). */
(function () {
  if (window.__advChrome) return;
  window.__advChrome = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- image protection (header setting "Proteggi le immagini") ----------
     Blocks right-click / long-press menus on images, dragging images out of the page
     and Ctrl/Cmd+S. It deters casual copying; screenshots can never be blocked. */
  function hasImageAt(e) {
    var t = e.target;
    if (t && t.closest && t.closest('img, picture, video, canvas, svg image, .adv-img, .adv-cf, .adv-lb, .adv-side, .adv-bn__visual')) return true;
    var els = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : [];
    for (var i = 0; i < els.length && i < 12; i++) {
      var el = els[i];
      if (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'CANVAS') return true;
      var bg = window.getComputedStyle(el).backgroundImage;
      if (bg && bg !== 'none' && bg.indexOf('url(') > -1) return true;
    }
    return false;
  }
  function initProtect() {
    if (!document.querySelector('[data-adv-protect="true"]')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    root.classList.add('adv-protect');
    document.addEventListener('contextmenu', function (e) { if (hasImageAt(e)) e.preventDefault(); }, true);
    document.addEventListener('dragstart', function (e) { var t = e.target; if (t && (t.tagName === 'IMG' || (t.querySelector && t.querySelector('img')))) e.preventDefault(); }, true);
    document.addEventListener('keydown', function (e) { if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) e.preventDefault(); }, true);
  }

  /* ---------- announcement bar ---------- */
  function initBar(bar) {
    if (bar.__adv) return; bar.__adv = true;
    var msgs = bar.querySelectorAll('.advh-bar__msg');
    if (msgs.length < 2 || reduce) return;
    var i = 0, speed = parseInt(bar.getAttribute('data-speed') || '5000', 10), timer;
    function next() {
      var cur = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }
    function start() { stop(); timer = setInterval(next, speed); }
    function stop() { if (timer) clearInterval(timer); }
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- header ---------- */
  function initHeader(h) {
    if (h.__adv) return; h.__adv = true;
    var wrap = h.closest('.advh-section') || h.parentElement;
    var mode = h.getAttribute('data-sticky');
    var bar = h.querySelector('.advh-bar');
    if (bar) initBar(bar);
    var prog = h.querySelector('.advh-progress span');
    var lastY = window.scrollY, ticking = false;

    function onScroll() {
      ticking = false;
      var y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 12);
      if (mode === 'smart') {
        var open = h.querySelector('.advh-item--mega.is-open') || h.querySelector('.advh-drawer.is-open');
        if (y > lastY + 6 && y > 160 && !open) wrap.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 160) wrap.classList.remove('is-hidden');
      }
      lastY = y;
      if (prog) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        prog.style.setProperty('--p', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* mega menu */
    h.querySelectorAll('.advh-item--mega').forEach(function (item) {
      var btn = item.querySelector('.advh-link');
      var t;
      function open() { clearTimeout(t); closeAll(item); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); wrap.classList.remove('is-hidden'); }
      function close() { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      btn.addEventListener('click', function (e) { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); });
      item.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { clearTimeout(t); t = setTimeout(open, 90); } });
      item.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) { clearTimeout(t); t = setTimeout(close, 220); } });
      /* close as soon as the pointer is outside both the menu button and the visible panel */
      var mega = item.querySelector('.advh-mega'), panel = item.querySelector('.advh-mega__in'), outT;
      function hit(r, x, y, pad) { return x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad; }
      function inside(x, y) {
        var b = btn.getBoundingClientRect(), p = panel ? panel.getBoundingClientRect() : b, pad = 10;
        if (hit(b, x, y, pad) || hit(p, x, y, pad)) return true;
        /* anything else shown in the dropdown, e.g. the "See all adventures" button */
        if (mega) for (var i = 0; i < mega.children.length; i++) { if (mega.children[i] !== panel && hit(mega.children[i].getBoundingClientRect(), x, y, pad)) return true; }
        /* the gap between the panel and the elements below it */
        if (mega) { var m = mega.getBoundingClientRect(); if (x >= p.left && x <= p.right && y >= p.bottom && y <= m.bottom) return true; }
        /* corridor from the button down to the panel */
        if (x >= b.left - 30 && x <= b.right + 30 && y >= b.bottom && y <= p.top + pad) return true;
        return false;
      }
      document.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !item.classList.contains('is-open')) return;
        if (inside(e.clientX, e.clientY)) { clearTimeout(outT); outT = null; return; }
        if (!outT) outT = setTimeout(function () { outT = null; close(); }, 180);
      }, { passive: true });
      document.addEventListener('mouseleave', function () { if (item.classList.contains('is-open')) close(); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      item.__close = close;
    });
    function closeAll(except) {
      h.querySelectorAll('.advh-item--mega.is-open').forEach(function (it) { if (it !== except && it.__close) it.__close(); });
    }
    document.addEventListener('click', function (e) { if (!h.contains(e.target)) closeAll(); });

    /* drawer */
    var drawer = h.querySelector('.advh-drawer');
    var burger = h.querySelector('.advh-burger');
    if (drawer && burger) {
      function openD() {
        drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true'); root.classList.add('advh-lock');
        var c = drawer.querySelector('.advh-drawer__close'); if (c) setTimeout(function () { c.focus(); }, 60);
      }
      function closeD() {
        drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false'); root.classList.remove('advh-lock'); burger.focus();
      }
      burger.addEventListener('click', openD);
      drawer.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', closeD); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      h.__closeDrawer = function () { if (drawer.classList.contains('is-open')) closeD(); };
    }
    /* add-to-cart buttons in the menus: close the menu, the cart drawer takes over */
    h.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-advh-add]')) return;
      closeAll();
      if (h.__closeDrawer) h.__closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAll();
      if (h.__closeDrawer) h.__closeDrawer();
    });
  }

  /* ---------- footer ---------- */
  function initFooter(f) {
    if (f.__adv) return; f.__adv = true;
    var items = f.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var vh = window.innerHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.1 });
      items.forEach(function (el) {
        if (el.getBoundingClientRect().top < vh) el.classList.add('is-in'); else io.observe(el);
      });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }
    var top = f.querySelector('[data-advf-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  function scan(scope) {
    root.classList.add('advc-js');
    (scope || document).querySelectorAll('.advh').forEach(initHeader);
    (scope || document).querySelectorAll('.advf').forEach(initFooter);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.advh-item--mega');
    if (item) { item.classList.add('is-open'); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest && e.target.closest('.advh-item--mega');
    if (item && item.__close) item.__close();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); initProtect(); });
  else { scan(); initProtect(); }
})();
